import React from 'react'
import _ from 'lodash'

import ReportTable from '../report_table'
import MemberTableOrg from './report_member_table'
import * as Helper from '../../../../helpers/helper'
import { truncateEnd } from '../helpers'

// port of cowebapp analytics/components/data_pulse/report_org_table.js
// (org rows use user_email / user_name response fields)
const ReportTableOrg = (props) => {

  const emailFormatter = (cell, row) => {
    return (
      <div
        className="d-flex org-email-column"
        title={row.user_email}
      >
        <div className='word-break-all'>
          {truncateEnd(Helper.capitalizeFirstLetter(_.isEmpty(row.user_name) ? '-' : row.user_name), 17)}
          <small>
            <div className="d-flex">
              <span className='word-break-all'>
                {truncateEnd(row.user_email, 23)}
              </span>
            </div>
          </small>
        </div>
      </div>
    )
  }

  const noDataIndication = () => {
    return (
      <div
        className="list-container text-center bg-white"
        style={{ padding: '10px' }}
      >
        <p className="m-0">
          No Activity Found
        </p>
      </div>
    )
  }

  const getTableData = () => {
    let tableData = []

    props.tableData.forEach(data => {
      let email = 0
      let phone = 0
      let name = 0

      data.stats.forEach(stat => {
        email += stat.email?.billable || 0
        phone += stat.phone?.billable || 0
        name += stat.name?.billable || 0
      })

      const total = email + phone + name

      if (total > 0) {
        tableData.push({
          user_id: data.user_id,
          user_email: data.user_email,
          user_name: data.user_name,
          user_role: data.user_role,
          stats: data.stats,
          total,
          email,
          phone,
          name
        })
      }
    })
    return tableData
  }

  const data = getTableData()
  const rowClasses = 'custom-row-class'
  const formatNumber = cell => cell === 0 ? '-' : Number(cell).toLocaleString()
  const colWidth = { width: '20%' }

  const columns = [
    {
      dataField: 'user_email',
      text: 'Member',
      formatter: emailFormatter,
      headerStyle: colWidth,
      style: colWidth,
      sort: true
    },
    {
      dataField: 'total',
      text: 'Total Credits',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right',
      sort: true
    },
    {
      dataField: 'email',
      text: 'Email Validation Credits',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right'
    },
    {
      dataField: 'phone',
      text: 'Phone Validation Credits',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right'
    },
    {
      dataField: 'name',
      text: 'Name Validation Credits',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right'
    }
  ]

  const expandRow = {
    className: 'expanding-row',
    parentClassName: 'parent-expand-row',
    renderer: row => (
      <MemberTableOrg
        memberData={row.stats}
        breakdown={props.userReportData.breakdown}
        id={row.user_id}
      />
    ),
  }

  const defaultSorted = [{
    dataField: 'total',
    order: 'desc'
  }]

  return (
    <div className="report-table">
      <ReportTable
        wrapperClasses="table-report-org table-responsive"
        expandRow={expandRow}
        noDataIndication={noDataIndication}
        keyField="user_id"
        data={data}
        columns={columns}
        rowClasses={rowClasses}
        defaultSorted={defaultSorted}
      />
    </div>
  )
}

export default ReportTableOrg
